import { Injectable } from "@angular/core";
import { AutoSaveService } from "../api/autosave/autosave.service";
import { FormInformation } from "src/app/models/api/form-information.model";
import { Config } from "src/app/config";
import { WidgetsService } from "../widgets/widgets.service";
import { ToastrService } from "ngx-toastr";
import { Logger } from "src/app/core/logger";
import { ActivatedRoute } from "@angular/router";
import { FormService } from "../api/form.service";
import { BehaviorSubject } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class keyOverrideService {
  FormVersionId: number = -1;
  formId 
  layoutRoot = this.widgetsService_.getLayoutRoot();
  isKeyOverWritePossible = new BehaviorSubject(false);
  isKeyOverWritePossible$ = this.isKeyOverWritePossible.asObservable();
  constructor(private widgetsService_: WidgetsService, private formService:FormService,  private route: ActivatedRoute, private autosaveService_:AutoSaveService, public widgetsService: WidgetsService,  private autosaveService: AutoSaveService,  private toastr: ToastrService,   private logger: Logger){
    
  this.route.queryParams.subscribe((params) => {
      this.formId = params.id;
    });
  }
    


  /**
    * will over write the clicked question key wiht provided fdkey
    * And update the template & checkbox value
    * @param widgetJson layout root 
    * @param fd_key provided by end user, it is a value that end user want to replace with exist key.
    * @param key of clicked primitive.
    * 
    * **/ 
  applyKeyOverride(widgetJson, fd_key, key_OfClickedQuestion){
    if(!this.isDuplicatekeysInThisFrom(key_OfClickedQuestion)){
      return;
    }
    let key_OfClickedQuestion_ = this.getKeyOfQuestionPrimitive(key_OfClickedQuestion);
    widgetJson.children.forEach((section, sIndex) =>{ // section loop
      section.children.forEach((question, qIndex)=>{ // question loop
        let isKeyFoundInQues = question.children.find(v=>v.key == key_OfClickedQuestion_) // find primitive in question childrent
        if(isKeyFoundInQues){
          let regx = new RegExp(key_OfClickedQuestion_, "g");
          let str = JSON.stringify(question.children);
          let repStr = str.replace(regx, fd_key);
          question.children = JSON.parse(repStr);
          let index_ = question.children.findIndex(x => x.key === fd_key);
          question.children[index_].fdKey =  fd_key;
        }
      })
    })
    return widgetJson;
  }

  /**
   * will check the duplicate primitive in form, if it contain more than one same primitive, it will return false.
   * @param key_OfClickedQuestion, clicked question key
   * **/ 

  isDuplicatekeysInThisFrom(key_OfClickedQuestion){
      let root_:any = this.layoutRoot.children
      let allFormPrimitives:any = [];
      root_.forEach(sections=>{
        sections.children.forEach(question => {
           allFormPrimitives.push(...question.children)
        })
      })
      let findPrim_ClickedPrimi = allFormPrimitives.filter((creature)=> {
        return creature.key == this.getKeyOfQuestionPrimitive(key_OfClickedQuestion);
      });
      if(findPrim_ClickedPrimi.length > 1){
        this.isKeyOverWritePossible.next(false)
        return false;
      }else{
        this.isKeyOverWritePossible.next(true)
        return true;
      }
  }



/**
 * @param widgetJson layout root 
 * @param fd_key provided by end user , it is a value that end user want to replace with exist key.
 * @param key of clicked primitive.
 * will replace the key with provided @param fd_key 
 * if question is checkbox than it will replace the value of checkbox also
 * 
 * **/ 
setkey(widgetJson, fd_key, key){
  let key_ = this.getKeyOfQuestionPrimitive(key);
    widgetJson.children.forEach((section, sIndex) =>{
      section.children.forEach((question, qIndex)=>{
          question.children.forEach((primitive, pIndex)=>{
              if (key_ == primitive.key) {
                  primitive.fdKey = fd_key;
              }
          })
      })
    })
    return widgetJson;
  }




/**
 * will save the form manually in DB
 * @formId id of a form
 * **/ 
  saveForm(){
    this.formService.getForm(this.formId).subscribe((form: any) => {      
      if (form.FormVersions && form.FormVersions.length > 0) {
        const latestVersion = form.FormVersions[form.FormVersions.length - 1];
        this.FormVersionId = latestVersion.Id;
        // Description. Warning: cant'be longer than 100 chars
        const description = window.navigator.userAgent;

        // Autosave initiated
        const localFormInformation: FormInformation = new FormInformation();
        const now = new Date();
        localFormInformation.UserId = Config.user.iNumber;
        localFormInformation.Timestamp = now;
        localFormInformation.Description = 'UserAgent: ' + description.substring(0, 80);
        localFormInformation.FormVersionId = this.FormVersionId;
        localFormInformation.Payload = this.widgetsService.getLayoutRoot();
        this.autosaveService
          .autosave(localFormInformation)
          .subscribe((resId: any) => {
            if (resId !== false) {
              const utcTime = now.toISOString();
              const utcDate = new Date(utcTime);
              this.widgetsService.setLastUpdated(utcDate);
              this.toastr.info('Form autosaved');
              this.widgetsService.resetPristine();
              location.reload();
            } else {
              this.logger.warn('Autosaved not executed successfully');
            }
          });
      }
    })

  }



  getKeyOfQuestionPrimitive(key){
    return key.split("_")[0]; 
  }

  
}
